export type State = number | null;

export const initialState: State = null;
